import axios from "axios";
import { APIRequest, ApiUrl } from "../Helpers/ApiHelper";

const PHYLLO_BASE_URL = "https://api.sandbox.getphyllo.com";
const URL_CREATE_USER = "/v1/users";
const URL_CREATE_USER_TOKEN = "/v1/sdk-tokens";
const URL_GET_ACCOUNT = "/v1/accounts";

const PHYLLO_CLIENT_ID = process.env.REACT_APP_PHYLLO_CLIENT_ID;
const PHYLLO_SECRET_ID = process.env.REACT_APP_PHYLLO_SECRET_ID;

const getAxiosInstance = () => {
  const api = axios.create({
    baseURL: PHYLLO_BASE_URL,
    auth: {
      username: PHYLLO_CLIENT_ID,
      password: PHYLLO_SECRET_ID,
    },
  });
  return api;
};

const createUser = async (username, externalId) => {
  try {
    const userId = localStorage.getItem("PHYLLO_USER_ID");
    if (Boolean(userId)) {
      return userId;
    }
    const api = getAxiosInstance();
    let response = await api.post(ApiUrl.createPhylloAccount, {
      name: username,
      external_id: externalId,
    });
    localStorage.setItem("PHYLLO_USER_ID", response.data.id);
    return response.data.id;
  } catch (err) {
    return err.body;
  }
};

const createUserToken = async () => {
  try {
    const BearerToken = localStorage.getItem("token") || "";

    const phyllo_user_id = localStorage.getItem("PHYLLO_USER_ID");
    const sdk_token = localStorage.getItem("PHYLLO_SDK_TOKEN");

    // ⛔ Avoid duplicate API call
    if (phyllo_user_id && sdk_token) {
      return { phyllo_user_id, sdk_token };
    }

    // ✅ Create axios instance LOCALLY (NO BASIC AUTH POSSIBLE)
    const api = axios.create({
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${BearerToken}`, // 🔒 FORCE BEARER
      },
    });

    // 🚫 HARD BLOCK Basic Auth
    delete api.defaults.auth;
    delete api.defaults.headers.common.Authorization;

    const response = await api.post(ApiUrl.createPhylloAccount, {});

    if (response?.data) {
      localStorage.setItem("PHYLLO_USER_ID", response.data.phyllo_user_id);
      localStorage.setItem("PHYLLO_SDK_TOKEN", response.data.sdk_token);

      return {
        phyllo_user_id: response.data.phyllo_user_id,
        sdk_token: response.data.sdk_token,
      };
    }

    return null;
  } catch (err) {
    console.error("Phyllo error:", err);

    return {
      error: true,
      message: err.message,
      data: err.response?.data,
    };
  }
};

const getAccounts = async (userId) => {
  try {
    const api = getAxiosInstance();
    let response = await api.get(`${URL_GET_ACCOUNT}?user_id=${userId}`);
    return response;
  } catch (err) {
    return err.body;
  }
};

export { createUser, createUserToken, getAccounts };
